import OptionsMenu from "./OptionsMenu";

export default OptionsMenu;



// WEBPACK FOOTER //
// ./src/commonComponents/OptionsMenu/index.js